import React from 'react'
import CurrencyFormat from 'react-currency-format';
import { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Index from '../../../Assets/Images/Index';
import Fade from 'react-reveal/Fade';
import { signUpUrl } from '../../../Container/App';

export default function Contact() {
  const [value, setValue] = useState({
    name: "",
    email: "",
    phone: "",
    type: "",
    message: "",
  })
  const [alerts, setAlerts] = useState({
    show: false,
    type: "success",
    msg: ""
  })

  const [errors, setErrors] = useState(false)
  const [btnLoader, setbtnLoader] = useState(false)

  const handleChange = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value })
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    setbtnLoader(true)
    if (!value.name || !value.email) {
      setbtnLoader(false)
      setErrors(true)
    } else {
      window.Email.send({
        Host: "smtp.elasticemail.com",
        Port: "2525",
        Username: "bsboby@gmail.com",
        // Password: "ACA8EB2268A95BE8CEB79EF24E39EBBD9D1F",
        Password: "83F09F4F13F7950BEE8BD39BCC4A18BDEFB8",
        From: "bsboby@gmail.com",
        To: "support@psd2html5.co",
        Subject: "Shopyxa | Consultation Request Received",
        Body: `<p>Name: ${value?.name}</p>
            <p>Email: ${value?.email}</p>
            <p>Phone number: ${value?.phone || "NA"}</p>
            <p>Query type: ${value?.type || "NA"}</p>
            <p>Message: ${value?.message || "NA"}</p>
            `,
      }).then((res) => {
        if (res == "OK") {
          setAlerts({ show: true, type: "success", msg: "Thanks for getting in touch with us! We have received your message request. Our team will be responding shortly." })
          setValue({
            name: "",
            email: "",
            phone: "",
            type: "",
            message: "",
          })
          setErrors(false)
          setbtnLoader(false)
          window.Email.send({
            Host: "smtp.elasticemail.com",
            Port: "2525",
            Username: "bsboby@gmail.com",
            Password: "83F09F4F13F7950BEE8BD39BCC4A18BDEFB8",
            From: "bsboby@gmail.com",
            To: value?.email,
            Subject: "Thanks for reaching us!",
            Body: `<p>Thanks for getting in touch with us! We have received your message request. Our team will be responding shortly.</p>`,
          }).then();
          setTimeout(() => {
            setAlerts({ show: false, type: "success", msg: "" })
          }, 3000);
        } else {
          setAlerts({ show: true, type: "error", msg: "Email not sent." })
          setTimeout(() => {
            setAlerts({ show: false, type: "success", msg: "" })
          }, 3000);
        }
      });
    }

  }
  console.log("value: ", value)
  return (
    <main>
      <section className='commonPT'>
        <div className="container">
          <div className="commonHeading text-center">
          </div>
          <Fade up>
            <div className="headingText mb-5">
              <h1>Get in touch</h1>
            </div>
          </Fade>
          <div className='blogDetailContent'>
            <div className='row'>
              <div className='col-md-6'>
                <Fade up>
                  <div className='contact_address_outer'>
                    <div className='contact_address_list'>
                      <div className='contact_address_icon'>
                        <img src={Index.map_icon} alt="" width={30} />
                      </div>
                      <div className='contact_address_text'>
                        <h5 className='mb-1'>Address</h5>
                        <p>Shopyxa <br /> Office: 918, 9th Floor, Tower - B, <br />Bestech Business Towers, <br /> Sector - 66, Mohali - 160066</p>
                      </div>
                    </div>
                    <div className='contact_address_list'>
                      <div className='contact_address_icon'>
                        <img src={Index.email_icon} alt="" width={30} />
                      </div>
                      <div className='contact_address_text'>
                        <h5 className='mb-1'>Email</h5>
                        <p><a href='mailto:support@shopyxa.com'>support@shopyxa.com</a></p>
                      </div>
                    </div>
                    <div className='contact_address_list'>
                      <div className='contact_address_icon'>
                        <img src={Index.phone_icon} alt="" width={30} />
                      </div>
                      <div className='contact_address_text'>
                        <h5 className='mb-1'>Phone</h5>
                        <p className='mb-2'><a href='tel:1724005441'>+91 172 4005441</a>, <a href='tel:1724025441'> 4025441</a></p>
                      </div>
                    </div>
                    <div className='contact_address_list'>
                      <div className='contact_address_icon'>
                        <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg"><circle className="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#f1592a"></circle>
                          <path d="M12.9821 10.1115C12.7029 10.7767 11.5862 11.442 10.7486 11.575C10.1902 11.7081 9.35269 11.8411 6.84003 10.7767C3.48981 9.44628 1.39593 6.25317 1.25634 6.12012C1.11674 5.85403 2.13001e-06 4.39053 2.13001e-06 2.92702C2.13001e-06 1.46351 0.83755 0.665231 1.11673 0.399139C1.39592 0.133046 1.8147 1.01506e-06 2.23348 1.01506e-06C2.37307 1.01506e-06 2.51267 1.01506e-06 2.65226 1.01506e-06C2.93144 1.01506e-06 3.21063 -2.02219e-06 3.35022 0.532183C3.62941 1.19741 4.32736 2.66092 4.32736 2.79397C4.46696 2.92702 4.46696 3.19311 4.32736 3.32616C4.18777 3.59225 4.18777 3.59224 3.90858 3.85834C3.76899 3.99138 3.6294 4.12443 3.48981 4.39052C3.35022 4.52357 3.21063 4.78966 3.35022 5.05576C3.48981 5.32185 4.18777 6.38622 5.16491 7.18449C6.42125 8.24886 7.39839 8.51496 7.81717 8.78105C8.09636 8.91409 8.37554 8.9141 8.65472 8.648C8.93391 8.38191 9.21309 7.98277 9.49228 7.58363C9.77146 7.31754 10.0507 7.1845 10.3298 7.31754C10.609 7.45059 12.2841 8.11582 12.5633 8.38191C12.8425 8.51496 13.1217 8.648 13.1217 8.78105C13.1217 8.78105 13.1217 9.44628 12.9821 10.1115Z" transform="translate(12.9597 12.9597)" fill="#fff"></path>
                          <path d="M0.196998 23.295L0.131434 23.4862L0.323216 23.4223L5.52771 21.6875C7.4273 22.8471 9.47325 23.4274 11.6637 23.4274C18.134 23.4274 23.4274 18.134 23.4274 11.6637C23.4274 5.19344 18.134 -0.1 11.6637 -0.1C5.19344 -0.1 -0.1 5.19344 -0.1 11.6637C-0.1 13.9996 0.624492 16.3352 1.93021 18.2398L0.196998 23.295ZM5.87658 19.8847L5.84025 19.8665L5.80154 19.8788L2.78138 20.8398L3.73978 17.9646L3.75932 17.906L3.71562 17.8623L3.43104 17.5777C2.27704 15.8437 1.55796 13.8245 1.55796 11.6637C1.55796 6.03288 6.03288 1.55796 11.6637 1.55796C17.2945 1.55796 21.7695 6.03288 21.7695 11.6637C21.7695 17.2945 17.2945 21.7695 11.6637 21.7695C9.64222 21.7695 7.76778 21.1921 6.18227 20.039L6.17557 20.0342L6.16817 20.0305L5.87658 19.8847Z" transform="translate(7.7758 7.77582)" fill="white" stroke="white" strokeWidth="0.2"></path></svg>
                      </div>
                      <div className='contact_address_text'>
                        <h5 className='mb-1'>Whatsapp</h5>
                        <p className='mb-2'><a href='https://wa.me/+919780897803' target="_blank" rel="noreferrer">+91 97808-97803</a></p>
                      </div>
                    </div>
                    {alerts.show ? <Alert variant="success">
                      {alerts.msg}
                    </Alert> : null}

                  </div>
                </Fade>
              </div>
              <div className='col-md-6'>
                <Fade up>
                  <div className='contact_address_form'>
                    <form onSubmit={handleSubmit}>
                      <div className=' mb-3'>
                        <input type="text" className={`form-control w-100 ${errors && value.name == "" ? "error" : ""}`} name="name" value={value.name} placeholder="Your name*" aria-label="Your name" onChange={handleChange} />
                        {errors && value.name === "" ? <small className='error'>Please enter your name</small> : null}
                      </div>
                      <div className=' mb-3'>
                        <input type="email" className={`form-control w-100 ${errors && value.email == "" ? "error" : ""}`} name="email" value={value.email} placeholder="Email Address*" aria-label="Email Address" onChange={handleChange} />
                        {errors && value.email === "" ? <small className='error'>Please enter your email</small> : null}
                      </div>
                      <div className=' mb-3'>
                        <CurrencyFormat format="+91 ##########" mask="" name="phone" value={value.phone} className="form-control w-100" placeholder="Phone number" onChange={handleChange} />
                      </div>
                      <div className='form-select-outer' onChange={handleChange}>
                        <select className='form-control w-100 mb-3' name="type" value={value.type}>
                          <option value="" disabled selected>Inquiry Type</option>
                          <option value={"General inquiries"}>General inquiries</option>
                          <option value={"Product or service questions"}>Product or service questions</option>
                          <option value={"Technical support inquiries"}>Technical support inquiries</option>
                          <option value={"Sales inquiries"}>Sales inquiries</option>
                          <option value={"Feedback inquiries"}>Feedback inquiries</option>
                        </select>
                      </div>
                      <textarea className="form-control w-100 mb-3" style={{ height: "auto", maxHeight: "200px", minHeight: "100px" }} value={value.message} placeholder="Message" aria-label="Message" rows={4} name="message" onChange={handleChange} />
                      {btnLoader ?
                        <div className='commonButton primary w-100'>Sending...</div>
                        :
                        // <button className='commonButton primary w-100'>{alerts.show ? alerts.msg : "Submit"}</button>
                        <button className='commonButton primary w-100'>Submit</button>
                      }


                    </form>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta commonPY">
        <div className="container">
          <Fade up>
            <div className="ctaInner">
              <div className="headingText white"><h2>Supporting Tomorrow's Entrepreneurs Today</h2></div>
              <div className="buttonOuter">
                <a className="commonButton outline" href={signUpUrl}>15 Days Free Trial</a>
              </div>
            </div>
          </Fade>
        </div>
      </section>

    </main>
  )
}
